import { render, staticRenderFns } from "./MailboxSection.vue?vue&type=template&id=090b5086&scoped=true&"
import script from "./MailboxSection.vue?vue&type=script&lang=js&"
export * from "./MailboxSection.vue?vue&type=script&lang=js&"
import style0 from "./MailboxSection.vue?vue&type=style&index=0&id=090b5086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b5086",
  null
  
)

export default component.exports